var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-status"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0026 1.83301C4.59685 1.83301 1.83594 4.59392 1.83594 7.99967C1.83594 11.4054 4.59685 14.1663 8.0026 14.1663C8.2111 14.1663 8.41699 14.156 8.6198 14.1359C8.89459 14.1085 9.1395 14.3092 9.16682 14.5839C9.19414 14.8587 8.99353 15.1036 8.71874 15.131C8.48302 15.1544 8.24411 15.1663 8.0026 15.1663C4.04456 15.1663 0.835938 11.9577 0.835938 7.99967C0.835938 4.04163 4.04456 0.833008 8.0026 0.833008C11.9606 0.833008 15.1693 4.04163 15.1693 7.99967C15.1693 8.24118 15.1573 8.48009 15.1339 8.71581C15.1066 8.9906 14.8617 9.19121 14.5869 9.16389C14.3121 9.13657 14.1115 8.89166 14.1388 8.61687C14.159 8.41406 14.1693 8.20817 14.1693 7.99967C14.1693 4.59392 11.4083 1.83301 8.0026 1.83301Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector (Stroke)_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99433 5.16699C7.34807 5.16699 6.82531 5.69 6.82531 6.33366C6.82531 6.97731 7.34807 7.50033 7.99433 7.50033C8.64067 7.50033 9.1634 6.97731 9.1634 6.33366C9.1634 5.69001 8.64067 5.16699 7.99433 5.16699ZM5.82531 6.33366C5.82531 5.13637 6.79713 4.16699 7.99433 4.16699C9.1916 4.16699 10.1634 5.13637 10.1634 6.33366C10.1634 7.53094 9.1916 8.50033 7.99433 8.50033C6.79713 8.50033 5.82531 7.53094 5.82531 6.33366ZM8.59417 10.6244C7.41835 10.4521 6.17332 10.8288 5.36164 11.6789C5.17094 11.8787 4.85445 11.886 4.65472 11.6953C4.45499 11.5046 4.44767 11.1881 4.63836 10.9884C5.69664 9.87997 7.27659 9.42066 8.73917 9.63501C9.01239 9.67505 9.20143 9.929 9.16138 10.2022C9.12134 10.4755 8.86739 10.6645 8.59417 10.6244Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82531 6.33366C6.82531 5.69 7.34807 5.16699 7.99433 5.16699C8.64067 5.16699 9.1634 5.69001 9.1634 6.33366C9.1634 6.97731 8.64067 7.50033 7.99433 7.50033C7.34807 7.50033 6.82531 6.97731 6.82531 6.33366Z",
    fill: "#919191"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector (Stroke)_3"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3333 10.5C11.3208 10.5 10.5 11.3208 10.5 12.3333C10.5 13.3459 11.3208 14.1667 12.3333 14.1667C13.3459 14.1667 14.1667 13.3459 14.1667 12.3333C14.1667 11.3208 13.3459 10.5 12.3333 10.5ZM9.5 12.3333C9.5 10.7685 10.7685 9.5 12.3333 9.5C13.8981 9.5 15.1667 10.7685 15.1667 12.3333C15.1667 13.8981 13.8981 15.1667 12.3333 15.1667C10.7685 15.1667 9.5 13.8981 9.5 12.3333Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.3333C10.5 11.3208 11.3208 10.5 12.3333 10.5C13.3459 10.5 14.1667 11.3208 14.1667 12.3333C14.1667 13.3459 13.3459 14.1667 12.3333 14.1667C11.3208 14.1667 10.5 13.3459 10.5 12.3333Z",
    fill: "#919191"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStatus);
export default __webpack_public_path__ + "static/media/user_status.a90d3dbc470e3b29e1a8ac49ee3d54ad.svg";
export { ForwardRef as ReactComponent };